import { Dispatch, SetStateAction } from 'react';
import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form';
import { ImportProcessSteps } from '@constants/process-steps';
import { Admission } from '@domain/admission';
import { ImportFormData } from '@hooks/import/type';

export const SPLITTER_SEMICOLON = ';';
export const SPLITTER_COMMA = ',';
export type SplitterTypes = typeof SPLITTER_SEMICOLON | typeof SPLITTER_COMMA | '';
export type ProcessImportCSVStep = ImportProcessSteps;
export interface ImportCSVForm {
  eventId: string;
  offerId: string;
  channelId: string;
  splitter: SplitterTypes;
}

export interface ImportCSVFormDataField {
  field: string;
}

export interface ImportCSVBookingField {
  id: string;
  validationRules: (values: string[]) => boolean | string | number[];
  error: string;
}

export interface ReviewImportProps {
  columns: Array<string[]>;
  onContinue: (qrCodeIssues: { duplicateRows: number[]; emptyRows: number[] }, formData: ImportFormData) => void;
  onDiscard: () => void;
}

export interface ImportCSVReviewForm extends ImportCSVForm {
  columns: ImportCSVFormDataField[];
}

export interface RowData {
  row: number;
  qrCode?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  phone?: string;
  idNumber?: string;
  language?: string;
  nationality?: string;
}

export interface ImportCSVErrorMessage {
  literal: string;
  columnValue?: number;
  columnLabel?: number;
  message?: string | boolean | number[];
  rows?: string;
}

export interface ValidateImportCSVFieldsArguments {
  formData: ImportCSVFormDataField[];
  processedColumns: string[][];
  bookingFields: ImportCSVBookingField[];
}

export interface ImportCSVFormErrorsProps {
  formColumnErrors?: Merge<FieldError, (Merge<FieldError, FieldErrorsImpl<ImportCSVFormDataField>> | undefined)[]>;
}

export interface ImportCsvStepsProps {
  step: ProcessImportCSVStep;
  setStep: (step: ProcessImportCSVStep) => void;
  offer?: Admission;
  fileName: string;
  rows: Array<string[]>;
  setRows: Dispatch<SetStateAction<Array<string[]>>>;
  setFileName: Dispatch<SetStateAction<string>>;
  localQrCodeIssues: { duplicateRows: number[]; emptyRows: number[] };
  onContinueReviewImport: (
    qrCodeIssues: { duplicateRows: number[]; emptyRows: number[] },
    formData: ImportFormData
  ) => void;
  onContinueConfirmImport: () => void;
  onClose: () => void;
}
